import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import CircularProgress from '@material-ui/core/CircularProgress';
import 'date-fns';
import Alert from '@material-ui/lab/Alert';
import { AutoDisabler, Validate, ValidationGroup } from 'mui-validate';
import { useTranslation } from 'react-i18next';
import UserDataService from '../../services/UserService';
import LocationDataService from '../../services/LocationService';
import DepartmentDataService from '../../services/DepartmentService';
// import DateFnsUtils from '@date-io/date-fns';
// import {
//     MuiPickersUtilsProvider,
//     KeyboardDatePicker,
// } from '@material-ui/pickers';

const useStyles = makeStyles(theme => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
    root: props => ({
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            width: '25ch',
        },
        '& .MuiButton-root': {
            margin: theme.spacing(1),
        },
        '& .MuiAlert-root': {
            width: '100%',
            '& > * + *': {
                marginTop: theme.spacing(1),
            },
        },
    }),
}));

const AddUserForm = () => {
    const { t } = useTranslation();
    const [locations, setLocations] = useState([]);
    const [allDepartments, setAllDepartments] = useState([]); // Store all departments
    const [filteredDepartments, setFilteredDepartments] = useState([]); // Store filtered departments
    const [generatingPin, setGeneratingPin] = useState(false);

    useEffect(() => {
        retrieveLocations();
    }, []);

    const retrieveLocations = () => {
        const locData = JSON.parse(localStorage.getItem('loc'));

        LocationDataService.getAll()
            .then(response => {
                let filteredLocations;

                if (locData && locData.id === 'all') {
                    // Show all locations
                    filteredLocations = response.data;
                } else if (Array.isArray(locData)) {
                    // loc_token stores location numbers, not internal ids
                    filteredLocations = response.data.filter(location =>
                        locData.includes(location.number)
                    );
                } else {
                    // If locData is invalid or not present, show no locations
                    filteredLocations = [];
                }

                setLocations(filteredLocations);
                console.log(filteredLocations);
            })
            .catch(e => {
                console.log(e);
            });
    };

    const [departments, setDepartments] = useState([]);

    const [loc] = React.useState(() => {
        const locData = localStorage.getItem('loc');
        return locData ? JSON.parse(locData).id : '';
    });

    useEffect(() => {
        retrieveDepartments();
    }, []);

    const retrieveDepartments = async () => {
        const locData = JSON.parse(localStorage.getItem('loc'));

        try {
            let response;

            if (Array.isArray(locData)) {
                const joinedValues = locData.join(',');
                response = await DepartmentDataService.getAll(joinedValues);
            } else if (locData.id === 'all') {
                response = await DepartmentDataService.adminAll();
            }

            if (response) {
                setAllDepartments(response.data); // Store all departments
                setFilteredDepartments([]); // Initialize filtered departments as empty
                console.log(response.data);
            }
        } catch (e) {
            console.log(e);
        }
    };

    const initialUserState = {
        id: null,
        // sap: '',
        name: '',
        loc_number: null,
        status: 3,
        loc_name: '',
        sub_loc_name: '',
        pin: '',
        email: null,
        phone: null,
        address: null,
        card: null,
        staff: false,
        guest_id: null,
    };

    const [user, setUser] = useState(initialUserState);
    const [submitted, setSubmitted] = useState(false);

    const handleInputChange = event => {
        const { name, value } = event.target;

        if (name === 'loc_name') {
            const selectedLocation = locations.find(
                location => location.name === value
            );
            if (selectedLocation) {
                // Filter departments based on the selected location's number
                const departmentsForLocation = allDepartments.filter(
                    department => department.parent === selectedLocation.number
                );

                setFilteredDepartments(departmentsForLocation);

                setUser(prevState => ({
                    ...prevState,
                    loc_name: value,
                    loc_number: selectedLocation.number,
                    sub_loc_name: '', // Reset department selection
                }));
            }
        } else {
            // Handle other inputs generically
            setUser(prevState => ({
                ...prevState,
                [name]: value,
            }));
        }
    };

    const [isLoading, setIsLoading] = useState(false);

    const saveUser = () => {
        setIsLoading(true); // Start loading

        var data = {
            name: user.name,
            loc_number: user.loc_number,
            loc_name: user.loc_name,
            sub_loc_name: user.sub_loc_name,
            status: user.status,
            sap: user.sap,
            pin: user.pin,
            email: user.email,
            phone: user.phone,
            address: user.address,
            card: user.card,
            staff: user.staff,
            guest_id: user.guest_id,
        };

        UserDataService.create(data)
            .then(response => {
                setUser({
                    id: response.data.id,
                    name: response.data.name,
                    loc_number: response.data.loc_number,
                    loc_name: response.data.loc_name,
                    sub_loc_name: response.data.sub_loc_name,
                    status: response.data.status,
                    sap: response.data.sap,
                    pin: response.data.pin,
                    email: response.data.email,
                    phone: response.data.phone,
                    card: response.data.card,
                    address: response.data.address,
                    staff: response.data.staff,
                    guest_id: response.data.guest_id,
                });
                setSubmitted(true);
                setIsLoading(false);
                console.log(response.data);
                setTimeout(function () {
                    window.location.reload(1);
                }, 2000);
            })
            .catch(e => {
                console.log(e);
            });
    };

    const newUser = () => {
        setUser(initialUserState);
        setSubmitted(false);
    };

    // The first commit of Material-UI
    const [selectedDate, setSelectedDate] = React.useState(
        new Date('2014-08-18T21:11:54')
    );

    const handleDateChange = date => {
        setSelectedDate(date);
    };

    const classes = useStyles();

    const currentHost = window.location.hostname;
    const currentPort = window.location.port;
    const isBilla = currentHost === 'billa.biodit.bg';
    const isDemo = currentHost === 'attendance-demo.biodit.info';
    const isBricolage = currentHost === 'bricolage.biodit.com';
    const isSwissport = currentHost === 'swissport.biodit.bg';
    const isLocalhost = currentHost === 'localhost' && currentPort === '4000';
    const isLocalhostBilla =
        currentHost === 'localhost' && currentPort === '4001';

    // Function to generate a random 4-digit PIN
    const generateRandomPin = () => {
        return Math.floor(1000 + Math.random() * 9000).toString();
    };

    // Function to check if the generated PIN is unique
    const findUniquePin = async () => {
        setGeneratingPin(true);
        let isUnique = false;
        let newPin = '';

        try {
            // Try up to 10 times to find a unique PIN
            for (let i = 0; i < 10; i++) {
                newPin = generateRandomPin();
                const response = await UserDataService.checkPinUnique(newPin);

                if (response.data && response.data.unique) {
                    isUnique = true;
                    break;
                }
            }

            if (isUnique) {
                // Force a clean state update with the new PIN
                setUser(prevState => {
                    const updatedUser = {
                        ...prevState,
                        pin: newPin,
                    };
                    return updatedUser;
                });
                // Add a slight delay to ensure state updates and UI refreshes
                setTimeout(() => {
                    const pinInput = document.getElementById(
                        'outlined-required pin'
                    );
                    if (pinInput) {
                        pinInput.focus();
                        pinInput.blur();
                    }
                }, 100);
            } else {
                console.error(
                    'Could not generate a unique PIN after several attempts'
                );
                // Handle the failure case - maybe display an error
            }
        } catch (error) {
            console.error('Error generating unique PIN:', error);
        } finally {
            setGeneratingPin(false);
        }
    };

    return (
        <div className="submit-form">
            {submitted ? (
                // <Alert onClose={() => { }}>Успешно добавен!</Alert>
                <div>
                    <Alert severity="success">
                        {t('employees.createForm.success')}
                    </Alert>
                    {/* <h4>You submitted successfully!</h4>
                    <button className="btn btn-success" onClick={newUser}>
                        Add
                    </button> */}
                </div>
            ) : (
                <ValidationGroup>
                    <form className={classes.root}>
                        <div>
                            <Validate
                                name="name"
                                required={[
                                    true,
                                    t('employees.createForm.required'),
                                ]}
                            >
                                <TextField
                                    required
                                    id="outlined-required name"
                                    label={t(
                                        'employees.createForm.employeeName'
                                    )}
                                    variant="outlined"
                                    name="name"
                                    value={user.name}
                                    onChange={handleInputChange}
                                    size="small"
                                />
                            </Validate>
                            <Validate
                                name="loc_name"
                                required={[
                                    true,
                                    t('employees.createForm.required'),
                                ]}
                            >
                                <TextField
                                    id="outlined-select-location loc_name"
                                    select
                                    required
                                    label={t('employees.createForm.location')}
                                    name="loc_name"
                                    value={user.loc_name}
                                    onChange={handleInputChange}
                                    size="small"
                                    variant="outlined"
                                >
                                    {locations.map(location => (
                                        <MenuItem
                                            key={location.id}
                                            value={location.name}
                                        >
                                            {location.name}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Validate>
                        </div>
                        <div>
                            <Validate
                                name="sub_loc_name"
                                required={[
                                    true,
                                    t('employees.createForm.required'),
                                ]}
                            >
                                <TextField
                                    id="outlined-select-sub-location sub_loc_name"
                                    select
                                    required
                                    name="sub_loc_name"
                                    label={t('employees.createForm.department')}
                                    value={user.sub_loc_name}
                                    onChange={handleInputChange}
                                    size="small"
                                    variant="outlined"
                                >
                                    <MenuItem></MenuItem>
                                    {(filteredDepartments.length > 0
                                        ? filteredDepartments
                                        : allDepartments
                                    ).map(department => (
                                        <MenuItem
                                            key={department.id}
                                            value={department.name}
                                        >
                                            {department.name}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Validate>
                            <Validate name="pin">
                                <TextField
                                    id="outlined-required pin"
                                    label={t('employees.createForm.pin')}
                                    variant="outlined"
                                    name="pin"
                                    value={user.pin || ''}
                                    onChange={handleInputChange}
                                    size="small"
                                    InputLabelProps={{
                                        shrink: Boolean(user.pin),
                                    }}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                {generatingPin ? (
                                                    <CircularProgress
                                                        size={20}
                                                    />
                                                ) : (
                                                    <IconButton
                                                        onClick={e => {
                                                            e.preventDefault();
                                                            findUniquePin();
                                                        }}
                                                        disabled={generatingPin}
                                                        edge="end"
                                                        size="small"
                                                        aria-label="generate unique PIN"
                                                    >
                                                        <AutorenewIcon />
                                                    </IconButton>
                                                )}
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Validate>
                        </div>
                        {/* <div>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDatePicker
                                        margin="normal"
                                        id="date-picker-dialog"
                                        label="Край"
                                        format="MM/dd/yyyy"
                                        name="start_date"
                                        id="start_date"
                                        value={selectedDate === user.start_date}
                                        onChange={handleDateChange}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                        size="small"
                                    />
                                    <KeyboardDatePicker
                                        margin="normal"
                                        id="date-picker-dialog"
                                        label="Край"
                                        format="MM/dd/yyyy"
                                        name="start_date"
                                        id="start_date"
                                        value={user.end_start_date}
                                        onChange={handleDateChange}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                        size="small"
                                    />
                                </MuiPickersUtilsProvider>
                            </div> */}
                        {/*<div>*/}
                        <div>
                            <Validate name="card">
                                <TextField
                                    id="outlined-required card"
                                    label={t('employees.createForm.cardNumber')}
                                    variant="outlined"
                                    name="card"
                                    value={user.card}
                                    onChange={handleInputChange}
                                    size="small"
                                />
                            </Validate>
                        </div>

                        {/*    <Validate name="phone">*/}
                        {/*        <TextField*/}
                        {/*            id="outlined-required phone"*/}
                        {/*            label="Телефон"*/}
                        {/*            variant="outlined"*/}
                        {/*            name="phone"*/}
                        {/*            value={user.phone}*/}
                        {/*            onChange={handleInputChange}*/}
                        {/*            size="small"*/}
                        {/*        />*/}
                        {/*    </Validate>*/}
                        {/*</div>*/}
                        <AutoDisabler>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={saveUser}
                                disabled={isLoading} // Disable button when loading
                            >
                                {isLoading
                                    ? t('employees.createForm.loading')
                                    : t('employees.createForm.create')}
                            </Button>
                        </AutoDisabler>
                    </form>
                </ValidationGroup>
            )}
        </div>
    );
};

export default AddUserForm;
